import { render, staticRenderFns } from "./printConfig.vue?vue&type=template&id=6ed366ef&"
import script from "./printConfig.vue?vue&type=script&lang=js&"
export * from "./printConfig.vue?vue&type=script&lang=js&"
import style0 from "./printConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports